import Svg, { Path } from 'react-native-svg'

export const MobileIcon = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M8.27 15.73c3.74 3.75 7.07 3.85 8.48 3.68.43-.055.83-.256 1.13-.57l1-1a2 2 0 0 0 0-2.83l-.71-.71a2 2 0 0 0-2.82 0l-.71.71a.997.997 0 0 1-1.095.218.998.998 0 0 1-.325-.219L9 10.79a.999.999 0 0 1 0-1.42l.71-.71a2 2 0 0 0 0-2.82L9 5.13a2 2 0 0 0-2.83 0l-1 1a1.89 1.89 0 0 0-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47Z"
      />
    </Svg>
  )
}
